function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 20a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 7a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7zm3-1a1 1 0 0 0-1 1v3h28V7a1 1 0 0 0-1-1H3zM2 25V14h28v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
});

var SvgCreditCard = function SvgCreditCard(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "40b7db14fd2028a2301f481990fabcac.svg";
export { SvgCreditCard as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/credit-card.svg
// module id = null
// module chunks = 